import React from 'react';
import { reduxForm, Field } from 'redux-form';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';



const validate = values => {
    const errors = {}
    const requiredFields = [
        'cuenta',
    ]
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Required'
        }
    })
    if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = 'Invalid email address'
    }
    if (values.cuenta && values.cuenta.length !== 9) {
        errors.cuenta = 'No. de cuenta no valido.'
    }
    return errors
}

const renderTextFieldb = (
    { input, label, meta: { touched, error }, ...custom },
) => (
        <TextField
            //hintText={label}
            //floatingLabelText={label}
            //errorText={touched && error}
            {...input}
            {...custom}
        />
    );

const renderTextField = ({
    label, name, type,
    input,
    meta: { touched, invalid, error }

}) => (
        <TextField
            label={label}
            placeholder={label}
            error={touched && invalid}
            helperText={touched && error}
            {...input}

            variant="outlined"
            margin="normal"

            fullWidth
            type={type}
            //id={name}

            autoComplete={name}
        />
    )

//const FrmCuentas = ({ classes, handleSubmit, submitting, onBack, pristine, submitSucceeded }) => {
const FrmCuentas = props => {
    const { handleSubmit, pristine, reset, submitting, classes } = props
    return (
        <form className={classes.form} onSubmit={handleSubmit}>
            <div>
                <Field name="cuenta" component={renderTextField} label="No. Cuenta" type="number" autoFocus />
            </div>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <Button type="submit"
                        fullWidth
                        variant="contained"
                        color="default"
                        disabled={pristine || submitting}
                        className={classes.submit} onClick={reset}>Limpiar</Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Button type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        disabled={pristine || submitting}
                        className={classes.submit}>Enviar</Button>
                </Grid>
            </Grid>
        </form>
    );
};

FrmCuentas.propTypes = {
    email: PropTypes.string,
    password: PropTypes.string,
    //age: PropTypes.number,
    //onBack: PropTypes.func.isRequired,
};



export default reduxForm({
    form: 'FrmCuentas', validate
})(FrmCuentas);


/*
export default function FrmCuentas(classes) {
    //const classes = useStyles();
    //debugger;

    //store.dispatch(setValor(event.target.innerText));

    const pasoAlgo = (event) => {
        store.dispatch(setValor("nueva info..."));
    };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paperLogin}>

                <Typography component="h1" variant="h5">
                    Inicio de sesión
                </Typography>
                <form className={classes.form} onSubmit={handleSubmit}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        type="email"
                        id="email"
                        label="Email"
                        name="email"
                        autoComplete="email"
                        autoFocus

                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Contraseña"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                    />

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        Enviar
          </Button>
                    <Grid container>
                        <Grid item xs>
                            <Link href="#" variant="body2">
                                Olvidó su contraseña?
              </Link>
                        </Grid>
                        <Grid item>
                            <Link href="#" variant="body2">
                                {"¿Aún no tienes cuenta? Regístrate"}
                            </Link>
                        </Grid>
                    </Grid>
                </form>
            </div>
            <Box mt={5}>

            </Box>
        </Container>
    );
}

//  <MadeWithLove />
*/
